<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>{{username}}s {{"definition-list-page.definitions" | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <app-boulder-list-entry (click)="showBoulder(boulder.boulderId)" *ngFor="let boulder of boulders"
                          [boulder-list-entry]="boulder"></app-boulder-list-entry>
</ion-content>
